import { render, staticRenderFns } from "./modalCreate.vue?vue&type=template&id=2919945e"
import script from "./modalCreate.vue?vue&type=script&lang=js"
export * from "./modalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports